import {
    Col,
    Container,
    Dropdown,
    Form,
    OverlayTrigger,
    Row,
    Table,
    Tooltip,
} from "react-bootstrap";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { ThreeDotSpinner } from "../loader";
import {
    apiUrl,
    dateFormate,
    formatWithDecimals,
} from "../../config/config";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";


export const ProMembership = () => {


    const [page, setPage] = useState(1);
    const [items, setItems] = useState(0);
    const [loader, setLoader] = useState(false);







    useEffect(() => {
        getProMemberships(page);
    }, []);


    async function getProMemberships(page) {
        setLoader(true);
        try {
            let params = {
                page: page - 1
            }
            const response = await apiService.getProMemberships(params);
            if (response?.status == 200) {
                setItems(response.data.data)
                console.log("response.data", response.data.data);
                setLoader(false);
            }

        } catch (error) {
            if (error?.response?.status == 401) {
                setLoader(false);
                swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
                    localStorage.clear();
                    window.location.href = "/";
                    console.log("OK button clicked after error alert");
                });
            } else {
                setLoader(false);
                swal({
                    icon: "error",
                    text: error?.response?.data?.message
                        ? error?.response?.data?.message
                        : error?.message,
                    button: "OK",
                }).then(() => {
                    console.log("OK button clicked after error alert");
                });
            }
        }
    };


    function handlePageChange(pageNumber) {
        setPage(pageNumber);
        getProMemberships(pageNumber);
    };




    return (
        <div className="dashboard-main-area">
            {loader == true ? <ThreeDotSpinner /> : ""}
            <Container fluid>
                <div className="dashboard-area-heading management-heading">
                    <Row className="row justify-content-center align-items-center mb-3">
                        <Col md={12} lg={11}>
                            <div className="heading-top-area">
                                <div className="d-flex ">
                                    <h2 className="align-self-center m-0">Pro Membership</h2>
                                </div>
                                <div className="heading-top-area-right">
                                    <a className="download-csv" download href={`${apiUrl}/admin/membership/generate-csv`}><i className="fa fa-download" aria-hidden="true"></i> Download Pro Membership CSV</a>

                                    {/* <div className="filter-top-area me-2">
                                        <Form.Group
                                            className=""
                                            controlId="exampleForm.ControlInput1"
                                        >
                                            <Form.Label className="mb-0">Filter:</Form.Label>
                                            <Select
                                                options={filterOptions}
                                                placeholder="All"
                                                onChange={(e) => (handleFilterChange(e.value), setFilterValue(e.value))}
                                            />
                                        </Form.Group>
                                    </div> */}

                                </div>
                            </div>
                        </Col>

                    </Row>
                    <Row className="pb-4 justify-content-center">
                        <Col md={12} lg={11}>
                            <div className="audit-request-box">
                                <Table responsive="sm" className="UserListTable">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Email Or Phone</th>
                                            <th>Wallet Address</th>
                                            <th>Solana Wallet Address</th>
                                            <th>Currently Active</th>
                                            <th>Expired At</th>
                                            <th>Created At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items != null && items?.total && items?.total > 0 ? (
                                            items?.list?.map((data, index) => {

                                                const serialNumber = (page - 1) * 10 + index + 1;

                                                return (
                                                    <tr key={index}>
                                                        <td>{serialNumber}</td>
                                                        <td>{data?.userId?.phone_or_email ? data?.userId?.phone_or_email : "N/A"}</td>
                                                        <td>{data?.userId?.wallet_address ? data?.userId?.wallet_address : "N/A"}</td>
                                                        <td>{data?.userId?.custodial_solana_address ? data?.userId?.custodial_solana_address : "N/A"}</td>
                                                        <td>{data?.isActive ? "Yes" : "No"}</td>
                                                        <td>
                                                            {moment(data?.expiryTime).format(dateFormate)}
                                                        </td>
                                                        <td>
                                                            {moment(data?.createdAt).format(dateFormate)}
                                                        </td>

                                                    </tr>
                                                );
                                            })
                                        )
                                            : (
                                                <tr className="no-dat-found-box">
                                                    <td colSpan={10}>
                                                        <img
                                                            src={
                                                                require("../../assets/images/no-data.svg")
                                                                    .default
                                                            }
                                                            alt="da"
                                                        />
                                                        <h3 className="text-center text-light">
                                                            No data found
                                                        </h3>
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </Table>

                                {items && items?.total && items?.total > 10 ? (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={10}
                                        totalItemsCount={items?.total}
                                        pageRangeDisplayed={5}
                                        onChange={(e) => handlePageChange(e)}
                                        prevPageText={"Prev"}
                                        nextPageText={"Next"}
                                    />
                                ) : null}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};
